import React from "react";

const Hero = () => {
  return (
    <>
      <div class="hero for-inner">
        <div class="container">
          <div class="hero-grid inner">
            <div class="hero-w-width on-inner">
              <h1 class="display-1">
                Migration & <span class="gray-text-color">Education News.</span>
              </h1>
              <div class="margin-30px">
                <p class="subhead">
                  Stay informed with the latest updates and insights on
                  migration and education.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Hero;
